module.exports = __webpack_public_path__ + "img/maximize-button.8fd199e8.jpg";